import { Toast, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { removeNotification } from '../../Actions/ui';

export const NotificationTypes = {
  SUCCESS: 'success',
  ERROR: 'error',
  SYSTEM_ERROR: 'system-error',
  USER_ERROR: 'user-error',
  INFO: 'info',
  WARNING: 'warning',
  LOADING: 'loading',
};

const Notifications = () => {
  const notifications = useSelector((state) => state.ui.notifications);
  const dispatch = useDispatch();

  const getClass = (notificationType) => {
    switch (notificationType) {
      case NotificationTypes.SUCCESS:
        return 'bg-success text-light';
      case NotificationTypes.SYSTEM_ERROR:
      case NotificationTypes.USER_ERROR:
      case NotificationTypes.ERROR:
        return 'bg-danger text-light';
      case NotificationTypes.INFO:
        return 'bg-info text-light';
      case NotificationTypes.WARNING:
        return 'bg-warning text-light';
      case NotificationTypes.LOADING:
        return 'bg-light text-dark';
      default:
        return '';
    }
  };

  return (
    <div className="notifications-container">
      {notifications.map((notification, idx) => {
        const isLoadingToast = notification.type === NotificationTypes.LOADING;

        return (
          <Toast
            key={notification.id}
            className={getClass(notification.type)}
            onClose={() => dispatch(removeNotification(notification.id))}
          >
            <Toast.Header closeButton={!isLoadingToast}>
              {isLoadingToast && (
                <Spinner animation="border" size="sm" className="mr-2" />
              )}
              <strong className="mr-auto text-capitalize">
                {notification.type}
              </strong>
            </Toast.Header>
            <Toast.Body>{notification.message}</Toast.Body>
          </Toast>
        );
      })}
    </div>
  );
};

export default Notifications;
